
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    plain: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    price: {
      color: 'red',
      fontWeight: 'semibold',
      fontSize: { all: 'md', md: 'lg' }
    }
  },
  computed: {
    longDesc() {
      return this.items.some(this.itemLongDesc)
    }
  },
  methods: {
    itemTitle({ name }) {
      return {
        html: name,
        fontSize: { all: 'md', md: 'lg' },
        tag: this.plain ? 'span' : 'h4'
      }
    },
    itemDescription(item, key) {
      return {
        html: item[key],
        width: { xl: '3/4' },
        color: 'grey-darker',
        marginTop: 'xs'
      }
    },
    itemLongDesc({ description }) {
      return description && description.length > 40
    }
  }
}
